import { SuperAdminScope } from 'src/components';
import { usePageHeader } from 'src/hooks/misc';
import { MagicFlowProvider } from './MagicFlowContext';
import { FlowRunDetailsModal } from './components/FlowRunDetailsModal';
import { MagicFlowAdminTabs } from './components/MagicFlowAdminTabs';
import { MagicFlowOrgSelector } from './components/MagicFlowOrgSelector';

const MagicFlowAdminContent = () => {
  usePageHeader({
    title: 'Magicflow Admin',
  });

  return (
    <div className="page-wrapper">
      <MagicFlowOrgSelector />
      <MagicFlowAdminTabs />
      <FlowRunDetailsModal />
    </div>
  );
};

const MagicFlowAdminPage = () => (
  <SuperAdminScope>
    <MagicFlowProvider>
      <MagicFlowAdminContent />
    </MagicFlowProvider>
  </SuperAdminScope>
);

export default MagicFlowAdminPage;
